import { jsx } from "react/jsx-runtime";
import { SimonSuccess } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockSimonSuccess = ({
  index,
  innerBlocks
}) => /* @__PURE__ */ jsx(SimonSuccess, { children: generateBlockList({
  blocks: innerBlocks
}) }, index);
BlockSimonSuccess.propTypes = {
  index: PropTypes.number
};
export {
  BlockSimonSuccess as default
};
